module.exports = __webpack_public_path__ + "img/matriz-3.af29e88d.jpg";